/**
 * 카운트다운 텍스트 생성
 * - 24시간 초과: "종료까지 N일 N시간 남음"
 * - 24시간 이내: "종료까지 N시간 N분 남음" 또는 "종료까지 N분 남음"
 */ export const getTimerText = (expiredAt)=>{
    if (!expiredAt) return null;
    const now = new Date();
    const deadline = new Date(expiredAt);
    const diffMs = deadline.getTime() - now.getTime();
    if (diffMs <= 0) return null;
    const totalMinutes = Math.floor(diffMs / 60000);
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor(totalMinutes % 1440 / 60);
    const minutes = totalMinutes % 60;
    if (days > 0) {
        return "종료까지 ".concat(days, "일 ").concat(hours, "시간 남음");
    } else if (hours > 0) {
        return "종료까지 ".concat(hours, "시간 ").concat(minutes, "분 남음");
    } else {
        return "종료까지 ".concat(minutes, "분 남음");
    }
};
